<div class="show-booking-modal">
  <div class="show-booking-modal__header">
    <h5 class="show-booking-modal__title">
      <i class="fa-solid fa-edit mr-2"></i>
      Edit Booking Content
    </h5>
    <button class="show-booking-modal__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <div class="show-booking-modal__body">
    <form #editForm="ngForm">
      <div class="mb-3">
        <label for="title" class="form-label">Title</label>
        <input type="text" class="form-control" id="title" [(ngModel)]="editedTitle" name="title"
          placeholder="Enter title" />
      </div>

      <div class="mb-3">
        <label for="icon" class="form-label d-flex justify-content-between align-items-center">
          <span>Icon</span>
          <button type="button" class="btn btn-sm btn-link p-0" (click)="toggleIconSelector('main')">
            <i class="fa-solid" [class.fa-chevron-down]="!iconSelectorExpanded['main']"
              [class.fa-chevron-up]="iconSelectorExpanded['main']"></i>
          </button>
        </label>
        <div class="icon-selector-section" [class.collapsed]="!iconSelectorExpanded['main']">
          <div class="icon-grid">
            <div *ngFor="let icon of promoIcons" class="icon-option" [class.selected]="editedIcon === icon"
              (click)="onIconSelected(icon)">
              <i [class]="icon"></i>
            </div>
          </div>
          <div class="custom-icon-upload-section">
            <div class="custom-icon-preview-wrapper">
              <div class="custom-icon-preview-content">
                <div class="custom-icon-placeholder" *ngIf="!customIconPreview['main']">
                  <i class="fa-solid fa-image"></i>
                  <span>No icon selected</span>
                </div>
                <img *ngIf="customIconPreview['main']" [src]="customIconPreview['main']" alt="Custom Icon Preview" class="custom-icon-preview" />
                <button type="button" class="custom-icon-remove" (click)="removeCustomIcon('main')" title="Remove" *ngIf="customIconPreview['main']">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
              <label for="customIcon" class="custom-icon-label">
                <input type="file" id="customIcon" name="customIcon" accept="image/*"
                  (change)="onCustomIconSelected($event, 'main')" class="custom-icon-input" />
                <span class="custom-icon-button">
                  <i class="fa-solid fa-upload mr-1"></i> Upload Custom Icon
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-3">
        <label for="description" class="form-label">Description</label>
        <textarea class="form-control" id="description" [(ngModel)]="editedDescription" name="description" rows="4"
          placeholder="Enter description"></textarea>
      </div>

      <div class="mb-3" *ngIf="type === 'connection'">
        <div class="d-flex justify-content-between align-items-center">
          <label for="contentButtonMobile" class="form-label mb-0">Button Mobile</label>
          <label class="toggle-switch">
            <input type="checkbox" id="contentButtonMobile" name="contentButtonMobile"
              [(ngModel)]="contentButtonMobile" />
            <span class="toggle-switch__slider"></span>
          </label>
        </div>
        <div class="mb-3 mt-2" *ngIf="contentButtonMobile">
          <input type="text" class="form-control" id="buttonMobileText" [(ngModel)]="buttonMobileText"
            name="buttonMobileText" placeholder="Enter button mobile text" />
        </div>
      </div>

      <div class="mb-3">
        <label for="bookNowText" class="form-label">Book Now Text</label>
        <input type="text" class="form-control" id="bookNowText" [(ngModel)]="editedBookNowText" name="bookNowText"
          placeholder="Enter Book Now Text" />
      </div>

      <div class="mb-4" *ngIf="type === 'connection'">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <label class="form-label mb-0">Create Content</label>
          <button type="button" class="btn btn-sm btn-primary" (click)="addContentItem()">
            <i class="fa-solid fa-plus mr-1"></i> Add Content
          </button>
        </div>

        <div class="content-items-container">
          <div *ngFor="let item of contentItems; let i = index; trackBy: trackByContentItem"
            class="content-item-card mb-3 p-3 border rounded">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Content {{ i + 1 }}</h6>
              <button type="button" class="btn btn-sm btn-danger" (click)="removeContentItem(i)"
                [disabled]="contentItems.length === 1" title="Remove Content">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>

            <div class="mb-3">
              <label [for]="'contentTitle' + i" class="form-label">Title</label>
              <input type="text" class="form-control" [id]="'contentTitle' + i" [(ngModel)]="item.title"
                [name]="'contentTitle' + i" placeholder="Enter title" />
            </div>

            <div class="mb-3">
              <label [for]="'contentIcon' + i" class="form-label d-flex justify-content-between align-items-center">
                <span>Icon</span>
                <button type="button" class="btn btn-sm btn-link p-0" (click)="toggleIconSelector('content' + i)">
                  <i class="fa-solid" [class.fa-chevron-down]="!iconSelectorExpanded['content' + i]"
                    [class.fa-chevron-up]="iconSelectorExpanded['content' + i]"></i>
                </button>
              </label>
              <div class="icon-selector-section" [class.collapsed]="!iconSelectorExpanded['content' + i]">
                <div class="icon-grid">
                  <div *ngFor="let icon of promoIcons" class="icon-option" [class.selected]="item.icon === icon"
                    (click)="onContentItemIconSelected(icon, i)">
                    <i [class]="icon"></i>
                  </div>
                </div>
                <div class="custom-icon-upload-section">
                  <div class="custom-icon-preview-wrapper">
                    <div class="custom-icon-preview-content">
                      <div class="custom-icon-placeholder" *ngIf="!customIconPreview[item._key || ('content' + (item.id || i))]">
                        <i class="fa-solid fa-image"></i>
                        <span>No icon selected</span>
                      </div>
                      <img *ngIf="customIconPreview[item._key || ('content' + (item.id || i))]" [src]="customIconPreview[item._key || ('content' + (item.id || i))]" alt="Custom Icon Preview" class="custom-icon-preview" />
                      <button type="button" class="custom-icon-remove" (click)="removeCustomIcon(item._key || ('content' + (item.id || i)))" title="Remove" *ngIf="customIconPreview[item._key || ('content' + (item.id || i))]">
                        <i class="fa-solid fa-times"></i>
                      </button>
                    </div>
                    <label [for]="'customContentIcon' + i" class="custom-icon-label">
                      <input type="file" [id]="'customContentIcon' + i" [name]="'customContentIcon' + i"
                        accept="image/*" (change)="onCustomIconSelected($event, item._key || ('content' + (item.id || i)))"
                        class="custom-icon-input" />
                      <span class="custom-icon-button">
                        <i class="fa-solid fa-upload mr-1"></i> Upload Custom Icon
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label [for]="'contentColor' + i" class="form-label d-flex justify-content-between align-items-center">
                <span>Color</span>
                <button type="button" class="btn btn-sm btn-link p-0" (click)="toggleColorSelector('content' + i)">
                  <i class="fa-solid" [class.fa-chevron-down]="!colorSelectorExpanded['content' + i]"
                    [class.fa-chevron-up]="colorSelectorExpanded['content' + i]"></i>
                </button>
              </label>
              <div class="color-selector-section" [class.collapsed]="!colorSelectorExpanded['content' + i]">
                <div class="color-grid">
                  <div *ngFor="let colorOption of colorOptions" class="color-option"
                    [class.selected]="item.color === colorOption.value"
                    [class.light-color]="isLightColor(colorOption.hex)"
                    (click)="onContentItemColorSelected(colorOption.value, i)" [title]="colorOption.name"
                    [style.background-color]="colorOption.hex">
                    <i class="fa-solid fa-check" *ngIf="item.color === colorOption.value"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-2">
              <label [for]="'contentContent' + i" class="form-label">Content</label>
              <app-editor [(innerValue)]="item.content"></app-editor>
            </div>

            <div class="mb-2">
              <div class="d-flex justify-content-between align-items-center">
                <label [for]="'showTags' + i" class="form-label mb-0">Show Tags</label>
                <label class="toggle-switch">
                  <input type="checkbox" [id]="'showTags' + i" [name]="'showTags' + i"
                    [(ngModel)]="item.showTags" />
                  <span class="toggle-switch__slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="my-button-3 secondary" (click)="cancel()">Cancel</button>
        <button type="button" class="my-button-3" (click)="save()">Save</button>
      </div>
    </form>
  </div>
</div>